// Auto-generated by robust sync script
export const migrated = {
  le_lien_de_votre_annonce_airbnb_est_obligatoire_:
    "De link naar je Airbnb-advertentie is vereist",
  la_note_airbnb_doit__tre_au_minimum_de_4_5_:
    "De Airbnb-beoordeling moet minimaal 4 tot 5 zijn",
  compte_cr______v_rifiez_votre_email_pour_activer_votre_acc_s_au_club_:
    "Account aanmaken controleer uw e-mail om uw toegang tot de club te activeren",
  club_r_serv__aux_h_tes_airbnb_not_s_4_5__:
    "Club gereserveerd voor Airbnb-gasten niet s'4 5",
  comparez_vos_gains_r_els: "Vergelijk uw werkelijke inkomsten",
  le_mod_le_traveltrok_est_gagnant_gagnant___le_voya:
    "De traveltrok-mod is een winnaar, de reiziger wint",
  votre_prix_sur_les_autres_sites: "Uw prijs op andere sites",
  diminuer_le_prix: "Verlaag de prijs",
  augmenter_le_prix: "Verhoog de prijs",
  net_pour_vous: "Netto voor jou",
  de_commissions: "Commissies",
  prix_pay__par_le_voyageur: "Prijs betaald door de reiziger",
  revenu___d_clarer__imp_ts_: "Inkomsten om belastingen aan te geven",
  vous_d_clarez_100__du_prix____commissions__:
    "U declareert 100 van de prijscommissies",
  de_frais_h_te: "Hostkosten",
  __0__compar____booking_: "0 vergelijkingsboeking",
  mod_le_frais_h_te__depuis_25_____: "Wijzig de hostkosten sinds 25",
  vous_d_clarez_100__du_prix_voyageur_:
    "U declareert 100% van de passagiersprijs",
  strat_gie_gagnante: "Winnende strategie",
  prix_voyageur: "Reiziger prijs",
  _5__pour_le_voyageur: "5 voor de reiziger",
  le_meilleur_des_deux_mondes: "Het beste van twee werelden",
  avantage_fiscal: "Belastingvoordeel",
  vous_d_clarez_moins__vous_payez_moins_d____imp_ts_:
    "U geeft minder aan, u betaalt minder belastingen",
  sc_nario___traveltrok_applique_5__de_frais_voyageu:
    "Sc nario traveltrok hanteert 5 reizigerstoeslagen",
  appartement: "Appartement",
  maison: "Thuis",
  inclut_villa_chalet: "Inclusief chaletvilla",
  loft: "Zolder",
  luxe: "Luxe",
  insolite: "Ongebruikelijk",
  autre: "Ander",
  campagne: "Campagne",
  mer: "Zee",
  montagne: "Berg",
  au_dessus_de_500_nuit: "Boven € 500/nacht",
  aucun_resultat_dynamique: "Geen dynamische resultaten",
  service_de_localisation_indisponible__r_essayez_da:
    "Locatieservice niet beschikbaar. Probeer het over enkele ogenblikken opnieuw",
  quel_type_de_logement_souhaitez_vou:
    "Welk type accommodatie wilt u aanbieden?",
  choisissez_la_cat_gorie_qui_d_crit_le_mieux_votre_:
    "Kies de categorie die uw accommodatie het beste beschrijft",
  quel_est_le_cadre_du_logement__: "Hoe is de woonomgeving?",
  o__est_situ__votre_logement__: "Waar ligt uw accommodatie?",
  pays_europ_en_de_r_f_rence: "Europees referentieland",
  ville__village__code_postal___: "Stad, dorp, postcode...",
  recherche_en_cours___: "Onderzoek in uitvoering...",
  recherche___: "Onderzoek...",
  localiser: "Lokaliseren",
  nous_utiliserons_cette_adresse_pour_localiser_votr:
    "Dit adres gebruiken wij om uw accommodatie te lokaliseren",
  localis_: "Gelokaliseerd",
  _copy__openstreetmap_france: "© OpenStreetMap Frankrijk",
  emplacement_valid_: "Gevalideerde locatie",
  d_crivez_votre_logement: "Beschrijf uw accommodatie",
  donnez_envie_aux_voyageurs_de_s_journer_chez_vous_:
    "Zorg ervoor dat reizigers bij u willen blijven",
  titre_de_l__annonce: "Advertentietitel",
  ex__charmant_studio_au_c_ur_de_paris:
    "Bijv.: Charmante studio in het hart van Parijs",
  soyez_concis_et_accrocheur: "Wees beknopt en pakkend",
  description_d_taill_e: "Gedetailleerde beschrijving",
  parlez_de_votre_logement__du_quartier__des__quipem:
    "Praat over uw accommodatie, de buurt, de voorzieningen...",
  mentionnez_les_points_forts: "Noem de sterke punten",
  voyageurs: "Reizigers",
  chambres: "Kamers",
  lits: "Bedden",
  salles_de_bain: "Badkamers",
  d_tails_du_logement: "Accommodatiegegevens",
  donnez_plus_d__informations_sur_la_capacit__d__acc:
    "Geef meer informatie over de opvangcapaciteit",
  surface__m__: "Oppervlakte (m²)",
  ex__85: "Bijv.: 85",
  ajoutez_des_photos: "Voeg foto's toe",
  mettez_en_valeur_votre_logement_avec_de_belles_ima:
    "Markeer uw huis met prachtige afbeeldingen",
  glissez_vos_photos_ici: "Sleep uw foto's hierheen",
  parcourez_vos_fichiers: "Blader door uw bestanden",
  jpg__png_jusqu____5_mo: "JPG, PNG (tot 5 MB)",
  d_j__en_ligne: "Al online",
  __uploader: "Om te uploaden",
  fixez_votre_prix: "Bepaal uw prijs",
  vous_pourrez_le_modifier___tout_moment_: "U kunt dit op elk moment wijzigen",
  par_nuit: "Per nacht",
  aper_u_de_votre_annonce: "Bekijk een voorbeeld van uw advertentie",
  titre_de_votre_annonce: "Titel van uw advertentie",
  nouveau: "Nieuw",
  localisation: "Locatie",
  suppression_du_profil__tapez_supprimer_puis_confirmez__si_la_suppression_compl_te_est_impossible__votre_profil_sera_mis_en_pause_et_masque_:
    "Verwijder het profieltype en bevestig vervolgens of volledige verwijdering onmogelijk is, uw profiel wordt gepauzeerd en verborgen",
  suppression_compl_te_indisponible__profil_mis_en_pause_et_masque_:
    "Voltooi Verwijderen Niet beschikbaar profiel Gepauzeerd en verbergen",
  preferences: "Voorkeuren",
  gerez_vos_unites__votre_visibilite_et_le_statut_de_votre_profil_:
    "Beheer uw eenheden, uw zichtbaarheid en de status van uw profiel",
  vous_restez_connecte_mais_vos_annonces_ne_sont_plus_actives_dans_les_suggestions_:
    "U blijft verbonden, maar uw advertenties zijn niet meer actief in de suggesties",
  votre_profil_et_vos_logements_ne_remontent_plus_dans_la_carte_et_les_pages_de_destinations_:
    "Uw profiel en uw accommodaties verschijnen niet meer op de kaart- en bestemmingspagina's",
  base_de_donnees_non_migree__vos_preferences_sont_sauvegardees_localement_pour_l_instant_:
    "Database niet gemigreerd, uw voorkeuren worden voorlopig lokaal opgeslagen",
  delai_depasse: "Deadline overschreden",
  echeance_aujourd__hui: "Vandaag verschuldigd",
  mois_restants: "Resterende maanden",
  nuits_dues_et_aucun_accueil_effectue:
    "Nachten verschuldigd en geen receptie uitgevoerd",
  suivi_des_echanges: "Toezicht op uitwisselingen",
  suivez_les_nuits_dues_dans_les_deux_sens__qui_vous_doit_des_nuits__qui_vous_devez_accueillir__et_le_temps_restant_pour_cl__turer_chaque_echange_:
    "Volg de nachten die u verschuldigd bent, wie u de nachten schuldig bent en de resterende tijd om elke uitwisseling te sluiten",
  nom__logement__contrat__dates__statut_des_deux_c_tes_et_temps_restant_:
    "Naam accommodatie contractdata status van beide partijen en resterende tijd",
  visualisez_vos_villes_cibles_et_les_rayons_de_recherche_autour_de_chaque_point_:
    "Visualiseer uw doelsteden en zoekradii rond elk punt",
  __d_couvrir___: "te dekken",
  les_incontournables___visiter_lors_de_votre_s_jour:
    "De essentiële plaatsen om te bezoeken tijdens uw verblijf",
  impossible_de_finaliser_la_demande__r_essaie_dans_:
    "Kan het verzoek niet voltooien, probeer het opnieuw",
  r_server_ton_s_jour___: "boek uw verblijf",
  parcours_simple_en_3__tapes__recherche__d_tails__v:
    "Eenvoudig zoeken in 3 stappen naar details v",
  recherche: "Onderzoek",
  validation: "Geldigmaking",
  demande_envoy_e: "Verzoek verzonden",
  un_h_te_va_te_r_pondre_rapidement_avec_les_d_tails:
    "Een gastheer zal snel reageren met details",
  cr_er_une_nouvelle_demande: "maak een nieuw verzoek aan",
  "1__ton_s_jour": "1 dag",
  arriv_e: "Aankomst",
  pers_: "Mensen",
  dates_flexibles: "Flexibele data",
  dates_exactes: "Exacte data",
  _3_jours: "3 dagen",
  _7_jours: "7 dagen",
  _14_jours: "14 dagen",
  je_voyage_avec_des_animaux: "Ik reis met dieren",
  "2__infos_r_servation": "2 reserveringsinformatie",
  nom_complet: "Volledige naam",
  ex__clara_martin: "ex Clara Martin",
  message___l_h_te: "Stuur een bericht naar de gastheer",
  pr_sentation_rapide__heure_d_arriv_e__besoins_part:
    "Snelle presentatie-aankomsttijd heeft een onderdeel nodig",
  "3__validation_de_la_r_servation": "3 validatie van de reservering",
  destination: "Bestemming",
  s_jour: "verblijf",
  flexibilit_: "Flexibiliteit",
  tarification_traveltrok: "traveltrok-prijzen",
  frais_plateforme: "Platformkosten",
  "1eur_voyageur___1eur_h_te": "1hun reiziger 1hun gastheer",
  incluse: "Inbegrepen",
  total_estim_: "Totale schatting",
  continuer: "Doorgaan",
  envoi___: "Verzenden",
  confirmer_ma_r_servation: "Bevestig mijn reservering",
  r_sum__intelligent: "R som slim",
  prix_base: "Basisprijs",
  total_actuel: "Huidig ​​totaal",
  inclut_1eur_voyageur___1eur_h_te_par_nuit__assuran:
    "Inclusief 1 gast en 1 gast per nacht Assuran",
  membres_actifs: "Actieve leden",
  note_moyenne: "Gemiddelde beoordeling",
  d_couvrez_: "ontdekken",
  points_forts: "Hoogtepunten",
  conseils_pratiques: "Praktisch advies",
  informations_pratiques: "Praktische informatie",
  meilleure_saison: "Beste seizoen",
  s_jour_moyen: "gemiddeld verblijf",
  langue: "Taal",
  monnaie: "Contant geld",
  fuseau_horaire: "Tijdzone",
  voir_les_logements: "Bekijk de accommodaties",
  nous_contacter: "Neem contact met ons op",
  villa: "Villa",
  logements_disponibles___: "Accommodaties beschikbaar",
  annonces___la_nuit_avec_h_tes_v_rifi_s_:
    "Overnachtingsvermeldingen met geverifieerde hosts",
  voir_la_carte_des_logements: "Zie de accommodatiekaart",
  h_te_v_rifi_: "geverifieerde gastheer",
  mod_le_traveltrok: "Mod de reisuitwisseling",
  r_server: "boeken",
  pas_encore_de_logements_ici: "Hier is nog geen accommodatie",
  sois_le_premier_h_te___proposer_son_logement___:
    "Wees de eerste verhuurder die zijn accommodatie aanbiedt",
  ajouter_mon_logement: "Voeg mijn accommodatie toe",
  destinations_proches: "Bestemmingen in de buurt",
  explorez_d_autres_destinations_en_: "Ontdek andere bestemmingen in",
  am_rique_du_nord: "Noord-Amerika",
  am_rique_du_sud: "Zuid-Amerika",
  oc_anie: "Oceanië",
  afrique: "Afrika",
  asie: "Azië",
  europe: "Europa",
  carte_des_destinations: "Bestemmingskaart",
  destinations_affich_es: "Weergegeven bestemmingen",
  continents: "Continenten",
  survolez_un_point_pour_voir_les_d_tails:
    "Beweeg over een punt om details te zien",
  _changes_r_alis_s: "wijzigingen aangebracht",
  mes_favoris: "Mijn favorieten",
  sauvegard_: "Back-up",
  tout_effacer: "Alles wissen",
  s_lectionn_: "Selectie",
  pour_comparaison: "Ter vergelijking",
  voir_la_comparaison: "Zie de vergelijking",
  trier_par__: "sorteren op",
  note: "Opmerking",
  _changes: "veranderingen",
  capacit_: "Capaciteit",
  pi_ces: "Stukken",
  type_de_logement: "Type accommodatie",
  effacer: "Om te wissen",
  r_initialiser_les_filtres: "R initialiseert filters",
  filtres_actifs__: "Actieve filters",
  aucun_r_sultat: "Geen resultaten",
  aucun_favori_ne_correspond___vos_filtres_:
    "Er zijn geen favorieten die overeenkomen met uw filters",
  comparaison_des_logements: "Accommodatie vergelijking",
  logements_s_lectionn_s: "Geselecteerde accommodaties",
  fermer: "Dichtbij",
  astuce: "Truc",
  utilisez_les_filtres_pour_affiner_vos_favoris_par:
    "Gebruik de filters om uw favorieten te verfijnen",
  type: "Vriendelijk",
  s_lectionnez_ensuite_jusqu______4_logements_pour_l:
    "Selecteer vervolgens maximaal 4 slots voor de",
  aucun_sch_ma_conversation_compatible_trouv__:
    "Geen sch mijn compatibele gesprek gevonden",
  souhaite_venir_dynamique: "Wens dynamisch te worden",
  aimerais_visiter_dynamique: "Wil graag dynamisch bezoeken",
  demande_ignor_e_: "Verzoek genegeerd",
  conversation_introuvable_: "Gesprek niet gevonden",
  impossible_d_ouvrir_la_discussion_pour_le_moment_:
    "Kan momenteel geen discussie openen",
  demande_supprim_e_: "Verzoek verwijderd",
  bonjour_merci_dynamique: "Hallo, bedankt dynamisch",
  demande_supprim_e_avec_un_message_poli_:
    "Verzoek verwijderd met een beleefd bericht",
  impossible_de_supprimer_cette_demande_pour_le_mome:
    "Kan dit verzoek momenteel niet verwijderen",
  demandes_directes: "Directe verzoeken",
  matching_auto: "Ze willen graag naar jouw regio komen",
  match_r_ciproque: "Wederzijdse wedstrijd",
  carte_secteur: "Sectorkaart",
  toutes: "Alle",
  lik_es: "Vond ik leuk",
  en_discussion: "Onder discussie",
  ignor_es: "Genegeerd",
  sans_date_pr_cise__juste__change_: "Zonder specifieke datum gewoon ruilen",
  date_pr_cise___dans_les_6_mois: "Specifieke datum binnen 6 maanden",
  date_pr_cise___dans_l_ann_e: "Specifieke datum in het jaar",
  flexible: "Flexibele",
  date_pr_cise: "Specifieke datum",
  dates_identiques: "Dezelfde data",
  dates_compatibles: "Compatibele data",
  dates_diff_rentes: "Verschillende data",
  dates_inconnues: "Data onbekend",
  souhaite_venir__: "Wens om te komen",
  voir_le_logement_cibl_: "Bekijk doelaccommodatie",
  personnes_int_ress_es_par_votre_secteur:
    "Mensen die geïnteresseerd zijn in jouw sector",
  vert___match_r_ciproque_ville___dates:
    "Groene wederzijdse wedstrijdstadsdata",
  int_r_t_entrant: "Inkomende rente",
  logement_cibl___: "Gerichte huisvesting",
  dates__: "Datums",
  sans_date_pr_cise: "Zonder specifieke datum",
  ouvrir_le_chat: "Chat openen",
  pas_encore_de_points_sur_la_carte: "Nog geen punten op de kaart",
  les_membres_qui_veulent_venir_dans_votre_secteur_a:
    "Leden die naar jouw regio willen komen",
  logement_vis_: "Gerichte accommodatie",
  demande: "Verzoek",
  message: "Bericht",
  logement_s_: "accommodatie(s)",
  annonce_indisponible: "Aankondiging niet beschikbaar",
  jour_s_: "dagen)",
  dur_e___d_finir: "Duur om te voltooien",
  match_auto: "Automatische match",
  r_ciproque: "Wederkerig",
  discuter_dans_la_messagerie: "Chatten in berichten",
  ignorer_la_demande: "Negeer het verzoek",
  ignorer: "Negeren",
  supprimer_avec_message_poli: "Verwijderen met beleefd bericht",
  poli: "Beleefd",
  supprimer_sans_message: "Verwijderen zonder bericht",
  suppr_: "Verwijderen",
  aucune_demande_pour_le_moment: "Momenteel geen verzoeken",
  le_tableau_est_pr_t__les_demandes_s_afficheront_ic:
    "Het bord is klaar en de verzoeken zullen hier verschijnen",
  surface: "Oppervlak",
  voyagez: "Reis",
  envie_d___changer_avec_: "Wil je mee veranderen",
  proposez_un__change_de_logement_et_d_couvrez_:
    "Stel een woningruil en dekking voor",
  gratuitement_: "Vrij",
  voir_la_fiche_du_logement: "Zie het accommodatieblad",
  carte_des_logements: "Woningkaart",
  r_sultats_visibles: "zichtbare resultaten",
  jour: "Dag",
  s_lectionn_s: "geselecteerde s",
  printemps: "Lente",
  _t_: "T",
  automne: "Herfst",
  hiver: "Winter",
  toute_l__ann_e: "Het hele jaar door",
  bonjour_host_dynamic: "Hallo dynamische gastheer",
  impossible_de_contacter_cet_h_te____errormessage__:
    "Kan geen contact opnemen met deze hostfoutmelding",
  impossible_de_contacter_cet_h_te_pour_le_moment_:
    "Kan momenteel geen contact opnemen met deze host",
  annonce_introuvable_: "Advertentie niet gevonden",
  choisissez_vos_dates_pour_envoyer_la_proposition_:
    "Kies uw data om het voorstel te verzenden",
  la_date_de_d_part_doit__tre_post_rieure___la_date_:
    "De vertrekdatum moet later zijn dan de aankomstdatum",
  proposition_d__change_avec_dates_pr_cises:
    "Uitwisselingsvoorstel met specifieke data",
  __logement_cibl_: "Doelgerichte huisvesting",
  __ville: "Stad",
  __arriv_e_souhait_e: "Gewenste aankomst",
  __d_part_souhait_: "Gewenst vertrek",
  __dur_e: "Duur",
  nuit_s_: "Nacht(en)",
  __voyageurs: "Reizigers",
  je_suis_ouvert_e____une_n_gociation_si_besoin_:
    "Indien nodig sta ik open voor onderhandeling.",
  indiquez_un_nombre_de_nuits_valide_pour_la_proposi:
    "Geef een geldig aantal nachten op voor het voorstel",
  proposition_d__change_flexible__sans_dates_fix_es_:
    "Flexibel ruilvoorstel zonder vaste data",
  __je_propose: "Ik stel voor",
  __je_demande: "vraag ik",
  on_valide_les_dates_ensemble_ensuite_selon_nos_dis:
    "Vervolgens valideren we de data samen op basis van onze beschikbaarheid.",
  indiquez_un_nombre_de_nuits_valide_: "Vul een geldig aantal nachten in",
  proposition_d__change__n_importe_quand_dans_l_ann_:
    "Uitwisselingsvoorstel op elk moment van het jaar",
  __dur_e_souhait_e: "Gewenste duur",
  __p_riode_pr_f_r_e: "Voorkeursperiode",
  je_suis_flexible_sur_les_dates_exactes_et_pr_t_e__:
    "Ik ben flexibel wat betreft exacte data en bereid om erover te praten.",
  proposition_invalide_: "Ongeldig voorstel",
  proposition_envoy_e__ouverture_de_la_discussion___:
    "Voorstel verzonden, discussie geopend...",
  impossible_d_envoyer_votre_proposition____errormes:
    "Kan uw voorstel niet verzenden",
  impossible_d_envoyer_votre_proposition_pour_le_mom:
    "Kan uw voorstel momenteel niet verzenden",
  logement_introuvable: "Accommodatie niet gevonden",
  retour_aux_logements: "Keer terug naar de accommodatie",
  annonce_airbnb: "Airbnb-advertentie",
  lien_airbnb_verification_helper:
    "Met deze link kunnen wij verifiëren dat u de beheerder van de advertentie bent.",
  aucune_photo_disponible: "Geen foto's beschikbaar",
  logement_propos__par: "Accommodatie aangeboden door",
  __propos_de_ce_logement: "Over deze accommodatie",
  aucune_description_fournie_: "Geen beschrijving opgegeven",
  ce_que_propose_ce_logement: "Wat deze accommodatie biedt",
  description_du_logement: "Beschrijving van de accommodatie",
  aucun__quipement_sp_cifi__: "Geen gespecificeerde apparatuur",
  _change_entre_h_tes: "uitwisseling tussen gastheren",
  votre_proposition_d__change: "Uw ruilvoorstel",
  quand_vous_voulez: "Wanneer je wilt",
  je_propose: "Ik stel voor",
  nuits_chez_moi: "Nachten bij mij thuis",
  je_demande: "vraag ik",
  nuits_chez_vous: "Nachten bij jou thuis",
  nombre_de_nuits: "Aantal nachten",
  p_riode_pr_f_r_e: "Voorkeursperiode",
  message__optionnel_: "Optioneel bericht",
  ex__nous_sommes_flexibles__on_peut_s_adapter___vos:
    "Omdat we flexibel zijn, kunnen we ons aan uw wensen aanpassen",
  entrer_en_n_gociation: "Ga in onderhandeling",
  envoyer_ma_proposition: "Stuur mijn voorstel",
  vous_pouvez_proposer_un__change_avec_ou_sans_dates:
    "Je kunt een uitwisseling aanbieden met of zonder data",
  informations_l_gales: "Juridische informatie",
  conditions_d____utilisation: "Gebruiksvoorwaarden",
  en_utilisant_traveltrok__vous_acceptez_d_utilise:
    "Door traveltrok te gebruiken, gaat u akkoord met het gebruik ervan",
  les__changes_se_font_directement_entre_membres__:
    "Uitwisselingen vinden rechtstreeks tussen leden plaats",
  traveltrok_peut_suspendre_un_compte_en_cas_de_co:
    "DONKEY TRAVEL kan een account opschorten in geval van mede",
  en_rejoignant_traveltrok__vous_acceptez_ces_engagements__la_confiance_se_construit_sur_des_actes_simples__honn_tet___respect_et_parole_tenue_:
    "Door lid te worden van DONKEY TRAVEL aanvaardt u deze verplichtingen. Vertrouwen is gebaseerd op eenvoudige acties.",
  cette_charte_est_align_e_avec_les_standards_publics_des_plateformes_majeures__respect_du_logement__fiabilit___anti_f_te__communication__:
    "Een solide charter in lijn met de best practices van andere bekende bedrijven.",
  retrait_du_club_en_cas_de_manquement_grave_ou_r_p_tition_:
    "Terugtrekking uit de club na herhaling of ernstig wangedrag.",
  exclusion_d_finitive: "Permanente uitsluiting",
  compte_limit__le_temps_de_v_rifier_les_faits_et_prot_ger_la_communaut__:
    "Beperkt account in afwachting van feiten.",
  suspension_temporaire: "Tijdelijke schorsing",
  rappel__crit_des_r_gles__avec_demande_de_correction_imm_diate_:
    "Herinnering aan de regels en correctie vereist.",
  avertissement_officiel: "Officiële waarschuwing",
  le_club_prot_ge_les_h_tes_fiables__les_manquements_r_p_t_s_ou_graves_entra_nent_des_mesures_imm_diates_:
    "De club beschermt betrouwbare gasten. Ernstige overtredingen resulteren in actie.",
  toute_annulation_doit__tre_document_e_dans_la_messagerie_et_trait_e_par_le_support_:
    "Elke annulering moet in een bericht worden gedocumenteerd en door de ondersteuning worden verwerkt.",
  on_n_annule_pas_un__change_sans_raison_valable__en_cas_de_force_majeure__sinistre__maladie_grave__impossibilit__l_gale___un_report_doit__tre_propos__au_plus_vite_:
    "Wij annuleren een ruil niet zonder geldige reden. In geval van overmacht (ramp, ernstige ziekte, juridische onmogelijkheid) moet zo snel mogelijk uitstel worden voorgesteld.",
  je_communique_vite_en_cas_de_doute_ou_de_changement_:
    "Bij twijfel of verandering communiceer ik snel.",
  j_accueille_quelqu_un_qui_exerce_le_m_me_m_tier_d_h_te_:
    "Ik verwelkom iemand die hetzelfde werk doet als gastheer.",
  j_assure_un_accueil_chaleureux_et_professionnel_:
    "Ik zorg voor een warm en professioneel welkom.",
  relation_entre_h_tes: "Relatie tussen gastheren",
  les__ventuels_frais_de_m_nage_sont_annonc_s_et_valid_s_avant_s_jour_:
    "Eventuele schoonmaakkosten worden vóór de omwisseling aangekondigd en gevalideerd.",
  les_informations_d_acc_s_et_de_fonctionnement_sont_claires_:
    "Toegangs- en bedieningsinformatie is duidelijk.",
  linge_et_pr_paration: "Wassen en voorbereiding",
  le_niveau_de_prestation_reste_identique__m_me_en__change_gratuit_:
    "Het serviceniveau blijft hetzelfde, zelfs bij een gratis uitwisseling.",
  le_logement_est_propre_et_pr_t___vivre_d_s_l_arriv_e_:
    "De accommodatie is bij aankomst schoon en klaar om in te wonen.",
  je_pr_pare_le_logement_comme_pour_un_client_airbnb_:
    "Ik bereid de accommodatie voor zoals voor een Airbnb-klant.",
  qualit__d_accueil__quivalente: "Equivalente ontvangstkwaliteit",
  je_respecte_le_calme__les_voisins_et_le_quartier_:
    "Ik respecteer de rust, de buren en de buurt.",
  aucune_f_te___v_nement_ou_invitation_non_autoris_e_dans_le_logement_:
    "Er zijn geen feesten, evenementen of ongeoorloofde uitnodigingen toegestaan ​​in de accommodatie.",
  je_respecte_le_r_glement_int_rieur_de_l_h_te_:
    "Ik respecteer de interne regels van de gastheer.",
  vie_de_quartier_et_r_gles: "Buurtleven en regels",
  quand_des_dates_sont_bloqu_es__je_m_engage___venir_:
    "Wanneer data geblokkeerd zijn, verbind ik mij ertoe te komen.",
  je_ne_mens_pas_sur_la_valeur_prix_habituel_de_mon_logement_:
    "Ik lieg niet over de gebruikelijke prijswaarde van mijn accommodatie.",
  je_ne_mens_pas_sur_ma_fiche__mon_historique_ni_mon_logement_:
    "Ik lieg niet over mijn profiel, mijn geschiedenis of mijn accommodatie.",
  honn_tet__et_fiabilit_: "Eerlijkheid en betrouwbaarheid",
  je_respecte_le_mat_riel__les__quipements_et_les_consignes_de_d_part_:
    "Ik respecteer de materialen, uitrusting en vertrekinstructies.",
  je_range_le_linge_utilis___ex__draps_en_boule___l_endroit_indiqu___pour_limiter_les_frais_de_m_nage_:
    "Gebruikt linnengoed (bijvoorbeeld lakens in een bol) berg ik op de aangegeven plek op, om de schoonmaakkosten te beperken.",
  je_rends_le_logement_aussi_propre_que_je_l_ai_trouv_:
    "Ik maak de accommodatie zo schoon als ik hem aantrof.",
  respect_total_du_logement: "Totaal respect voor huisvesting",
  traveltrok_est_un_club_d_h_tes_s_rieux__une_bonne_note_implique_une_conduite_exemplaire__en_tant_que_voyageur_comme_en_tant_qu_h_te_:
    "DONKEY TRAVEL is een serieuze gastclub; een goede beoordeling impliceert voorbeeldig gedrag, zowel als reiziger als als gastheer.",
  "howItWorks.cta.explore": "Bestemmingen verkennen",
  "howItWorks.cta.signup": "Bekijk onze aanbiedingen",
  "howItWorks.cta.subtitle":
    "Begin met het huren van je eigen plek. Activeer vervolgens uitwisseling als je wilt uitwisselen tussen hosts.",
  "howItWorks.cta.title": "Klaar om uw verhuur te lanceren?",
  publiez_votre_logement__validez_votre_profil_et_commencez_a_recevoir_des_propositions_d_echange_:
    "Publiceer uw accommodatie, valideer uw profiel en ontvang ruilaanbiedingen.",
  visualisez_la_densite_des_logements_deja_inscrits_dans_le_club__les_points_restent_anonymes__pas_d_adresse__pas_de_detail__juste_la_dynamique_du_reseau_:
    "Bekijk de dichtheid van de woningen die al bij de club zijn geregistreerd. De punten blijven anoniem (geen adres, geen details, alleen netwerkdynamiek).",
  prenez_du_recul_pour__viter_l__puisement_li___l_accueil_continu_:
    "Neem een ​​stap terug om een ​​burn-out door continue hosting te voorkomen.",
  _an: "/ jaar",
  traveltrok_connecte_les_h_tes_du_monde_entier_pour_des_s_jours_authentiques_et_abordables_:
    "DONKEY TRAVEL verbindt gasten over de hele wereld voor authentieke en betaalbare verblijven.",
  ____100__made_in_france__picardie_: "🇫🇷 100% gemaakt in Frankrijk (Picardie)",
  pas_la_silicon_valley__mais_la_vall_e_de_la_haute_somme_:
    "Niet Silicon Valley, maar de vallei van de Haute-Somme.",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_not_s_4_5___offre_lancement_2026___50__:
    "Uitwisselingen in heel Europa tussen Airbnb-hosts met een beoordeling van 4,5+. Lanceringsaanbod 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes_creuses_en_vraies_respirations_sans_exploser_votre_budget_:
    "Na maandenlang hosten kunt u uw rustige periodes omzetten in echte adempauze zonder uw budget te belasten.",
  prenez_du_recul_pour__viter_l__puisement_li____l_accueil_continu_:
    "Neem een ​​stap terug om een ​​burn-out door continue hosting te voorkomen.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exigences_du_terrain__puis_partagez_vos_m_thodes_et_vos_retours_d_exp_rience_:
    "Verwelkom gasten die de vereisten van het vakgebied al kennen en deel vervolgens uw methoden en feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_membres_du_club_:
    "Reis tegen lagere kosten dankzij uitwisselingen tussen clubleden.",
  quand_votre_quota_local_est_atteint__vous_pouvez__changer_hors_plateforme_sous_r_serve_de_conformit__locale_:
    "Wanneer uw lokale quotum is bereikt, kunt u buiten het platform handelen, op voorwaarde van lokale naleving.",
  traveltrok_est_une_r_volution_europ_enne__une_plateforme_d__changes_pour_les_h_tes_qui_paient_d_j__chauffage__taxes__imp_ts___lectricit___internet_et_entretien__et_accueillent_toute_l_ann_e_comme___l_h_tel__ici__vous__changez_avec_des_h_tes_qui_savent_accueillir__vous_partagez_vos_exp_riences__puis_vous_partez_d_couvrir_un_autre_endroit_sans_vous_ruiner_:
    "DONKEY TRAVEL is een Europese revolutie: een uitwisselingsplatform voor gasten die al betalen voor verwarming, belastingen, elektriciteit, internet en onderhoud, en het hele jaar door welkom zijn zoals in een hotel. Hier heb je contact met gastheren die weten hoe ze je moeten verwelkomen, je deelt je ervaringen en vervolgens ga je een andere plek ontdekken zonder veel geld uit te geven.",
  ___notre_mod_le_repose_uniquement_sur_les_abonnements__pas_sur_l_exploitation_des_donn_es_:
    "👉 Ons model is uitsluitend gebaseerd op abonnementen, niet op de exploitatie van data.",
  ___sans_publicit___sans_revente_de_donn_es__100___financ__par_les_membres_:
    "🔒 Advertentievrij. Zonder wederverkoop van gegevens. 100% door leden gefinancierd.",
  le_club_n_est_pas_un_conseil_juridique___chaque_membre_doit_respecter_les_r_gles_locales__d_clarations__quotas__copropri_t___fiscalit___etc___:
    "De club is geen juridisch advies; elk lid moet de lokale regels respecteren (aangiften, quota, mede-eigendom, belastingen, enz.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_h_tes_airbnb:
    "Een Europees uitwisselingsplatform gereserveerd voor Airbnb-hosts",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_unique_pour__changer_dans_toute_l_europe_:
    "Privéclub voor gasten met een beoordeling van 4,5+: een uniek abonnement om te wisselen in heel Europa.",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_ou__gale___4_5_:
    "Gereserveerd voor Airbnb-hosts met een beoordeling groter dan of gelijk aan 4,5.",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eur_an__prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "50% reductie in 2026: 25EUR/jaar in plaats van 50EUR/jaar. Levenslange prijsgarantie voor de eerste 1000 registraties.",
  basse_saison__pause__rencontres_entre_h_tes___conomies_vacances__tout_est_pens__pour_les_h_tes_actifs_en_europe_:
    "Laagseizoen, pauzes, ontmoetingen tussen gasten, vakantiebesparingen: alles is ontworpen voor actieve gasten in Europa.",
  accueillez_des_membres_et_faites_vous_accueillir_en_retour__un__change_simple__direct_et_sans_argent_entre_propri_taires_:
    "Verwelkom leden en word terug welkom geheten. Een eenvoudige, directe en geldloze uitwisseling tussen eigenaren.",
  _nous_avons__chang__notre_maison___lyon_contre_une_villa_en_corse__co_t___0___:
    "'Wij hebben ons huis in Lyon ingeruild voor een villa op Corsica. Kosten: € 0.'",
  pas_de_monnaie__pas_de_points__juste_un_accord_entre_deux_propri_taires__je_viens_chez_toi__tu_viens_chez_moi_:
    "Geen munten, geen punten. Gewoon een overeenkomst tussen twee eigenaren. Ik kom naar jouw huis, jij komt naar mijn huis.",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous_mettez_d_accord_pour__changer_vos_logements_:
    "Je vindt een lid dat je leuk vindt en gaat ermee akkoord om van accommodatie te wisselen.",
  pas_de_points___compter__juste_le_plaisir_de_partager_et_de_se_rencontrer_:
    "Geen punten om te tellen. Gewoon het plezier van delen en ontmoeten.",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_voyager_:
    "Het is meer dan een economie, het is een nieuwe manier van reizen.",
  les__changes_sont_totalement_gratuits__pas_de_frais_de_service__pas_de_frais_de_m_nage__sauf_accord_sp_cifique__:
    "Uitwisselingen zijn volledig gratis. Geen servicekosten, geen schoonmaakkosten (tenzij specifiek overeengekomen).",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_accueillez_quelqu_un_qui_conna_t_la_valeur_d_un_logement_:
    "Alleen geverifieerde hosts kunnen handelen. U verwelkomt iemand die de waarde van een woning kent.",
  oubliez_la_valeur_des_points__une_nuit_est_une_nuit__l__change_est_bas__sur_la_confiance_entre_h_tes_:
    "Vergeet de waarde van punten. Een nacht is een nacht. De uitwisseling is gebaseerd op vertrouwen tussen hosts.",
  __an: "/ jaar",
  _changes_dans_toute_l_europe_entre_h_tes_airbnb_no:
    "Uitwisselingen in heel Europa tussen Airbnb-hosts met een beoordeling van 4,5+. Lanceringsaanbod 2026: -50%.",
  apr_s_des_mois_d_accueil__transformez_vos_p_riodes:
    "Na maandenlang hosten kunt u uw rustige periodes omzetten in echte adempauze zonder uw budget te belasten.",
  prenez_du_recul_pour__viter_l__puisement_li____l_a:
    "Neem een ​​stap terug om een ​​burn-out door continue hosting te voorkomen.",
  accueillez_des_h_tes_qui_connaissent_d_j__les_exig:
    "Verwelkom gasten die de vereisten van het vakgebied al kennen en deel vervolgens uw methoden en feedback.",
  voyagez___co_t_r_duit_gr_ce_aux__changes_entre_mem:
    "Reis tegen lagere kosten dankzij uitwisselingen tussen clubleden.",
  quand_votre_quota_local_est_atteint__vous_pouvez__:
    "Wanneer uw lokale quotum is bereikt, kunt u buiten het platform handelen, op voorwaarde van lokale naleving.",
  la_r_volution_des_h_tes_en_europe: "De gastrevolutie in Europa",
  enfin_une_pause_pour_les_h_tes_airbnb_not_s_4_5_:
    "Eindelijk een pauze voor Airbnb-hosts met een beoordeling van 4,5+",
  traveltrok_est_une_r_volution_europ_enne__une_plat:
    "DONKEY TRAVEL is een Europese revolutie: een uitwisselingsplatform voor gasten die al betalen voor verwarming, belastingen, elektriciteit, internet en onderhoud, en het hele jaar door welkom zijn zoals in een hotel. Hier heb je contact met gastheren die weten hoe ze je moeten verwelkomen, je deelt je ervaringen en vervolgens ga je een andere plek ontdekken zonder veel geld uit te geven.",
  prix_garanti___vie_pour_les_1000_premiers_inscrits:
    "Levenslange prijsgarantie voor de eerste 1000 registraties.",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produi:
    "Bij DONKEY TRAVEL zijn uw gegevens geen product.",
  nous_ne_vendons_jamais_les_informations_de_nos_mem:
    "Wij verkopen nooit de gegevens van onze leden.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___:
    "Wij delen geen gegevens met derden voor commerciële doeleinden.",
  le_site_est_s_curis__et_vos__changes_restent_priv_:
    "De site is beveiligd en uw uitwisselingen blijven privé.",
  traveltrok_est_garanti_sans_publicit____vous__tes_:
    "DONKEY TRAVEL is gegarandeerd reclamevrij: jij bent het lid, niet het product.",
  ___notre_mod_le_repose_uniquement_sur_les_abonneme:
    "👉 Ons model is uitsluitend gebaseerd op abonnementen, niet op de exploitatie van data.",
  ___sans_publicit___sans_revente_de_donn_es__100___:
    "🔒 Advertentievrij. Zonder wederverkoop van gegevens. 100% door leden gefinancierd.",
  le_club_n_est_pas_un_conseil_juridique___chaque_me:
    "De club is geen juridisch advies; elk lid moet de lokale regels respecteren (aangiften, quota, mede-eigendom, belastingen, enz.).",
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_:
    "Een Europees uitwisselingsplatform gereserveerd voor Airbnb-hosts",
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u:
    "Privéclub voor gasten met een beoordeling van 4,5+: een uniek abonnement om te wisselen in heel Europa.",
  acc_s_r_serv_: "Gereserveerde toegang",
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_:
    "Gereserveerd voor Airbnb-hosts met een beoordeling groter dan of gelijk aan 4,5.",
  europe_unique: "Enkel Europa",
  "50eur_an_pour__changer_dans_toute_l_europe_":
    "50EUR/jaar om te ruilen in heel Europa.",
  lancement_2026: "Lancering 2026",
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu:
    "50% reductie in 2026: 25EUR/jaar in plaats van 50EUR/jaar. Levenslange prijsgarantie voor de eerste 1000 registraties.",
  club_d__change_h_tes_airbnb: "Airbnb Host Exchange Club",
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes:
    "Optimaliseer uw daluren dankzij uitwisselingen",
  basse_saison__pause__rencontres_entre_h_tes___cono:
    "Laagseizoen, pauzes, ontmoetingen tussen gasten, vakantiebesparingen: alles is ontworpen voor actieve gasten in Europa.",
  r_serv__aux_h_tes_traveltrok: "Gereserveerd voor DONKEY TRAVEL-gasten",
  voyagez_gratuitement_gr_ce___votre_logement:
    "Reis gratis met uw accommodatie",
  accueillez_des_membres_et_faites_vous_accueillir_e:
    "Verwelkom leden en word terug welkom geheten. Een eenvoudige, directe en geldloze uitwisseling tussen eigenaren.",
  devenir_h_te: "Word een gastheer",
  comment__a_marche__: "Hoe werkt het?",
  _nous_avons__chang__notre_maison___lyon_contre_une:
    "'Wij hebben ons huis in Lyon ingeruild voor een villa op Corsica. Kosten: € 0.'",
  amis_partageant_un_repas_en_corse: "Vrienden delen een maaltijd op Corsica",
  sophie___marc__membres_depuis_2023: "Sophie & Marc, lid sinds 2023",
  pas_besoin_d__changer_aux_m_mes_dates____tu_viens:
    "Ruilen op dezelfde data is niet nodig: jij komt in juni naar mijn huis, ik kom in september naar jouw huis!",
  l__change_direct___simple_et_humain:
    "Directe uitwisseling: eenvoudig en menselijk",
  pas_de_monnaie__pas_de_points__juste_un_accord_ent:
    "Geen munten, geen punten. Gewoon een overeenkomst tussen twee eigenaren. Ik kom naar jouw huis, jij komt naar mijn huis.",
  "1__accord_mutuel": "1. Onderlinge overeenstemming",
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous:
    "Je vindt een lid dat je leuk vindt en gaat ermee akkoord om van accommodatie te wisselen.",
  "2__flexibilit__totale": "2. Totale flexibiliteit",
  "3__z_ro_comptabilit_": "3. Nulboekhouding",
  pas_de_points___compter__juste_le_plaisir_de_parta:
    "Geen punten om te tellen. Gewoon het plezier van delen en ontmoeten.",
  pourquoi_les_h_tes_adorent_ce_syst_me__:
    "Waarom houden verhuurders van dit systeem?",
  plus_qu_une__conomie__c_est_une_nouvelle_fa_on_de_:
    "Het is meer dan een economie, het is een nieuwe manier van reizen.",
  "0__de_frais": "0 € kosten",
  les__changes_sont_totalement_gratuits__pas_de_frai:
    "Uitwisselingen zijn volledig gratis. Geen servicekosten, geen schoonmaakkosten (tenzij specifiek overeengekomen).",
  confiance_totale: "Totaal vertrouwen",
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac:
    "Alleen geverifieerde hosts kunnen handelen. U verwelkomt iemand die de waarde van een woning kent.",
  simplicit_: "Eenvoud",
  oubliez_la_valeur_des_points__une_nuit_est_une_nui:
    "Vergeet de waarde van punten. Een nacht is een nacht. De uitwisseling is gebaseerd op vertrouwen tussen hosts.",
  rejoignez_la_communaut__des_h_tes: "Sluit u aan bij de gastgemeenschap",
  rejoignez_la_communaut__et_commencez____changer_:
    "Sluit je aan bij de community en begin met chatten.",
  commencer_maintenant: "Begin nu",
  chargement___: "Laden...",
  accueil: "Welkom",
  comment_a_marche: "Hoe het werkt",
  vos_engagements: "Jouw verplichtingen",
  pays: "Land",
  logements: "Huisvesting",
  _change_h_te: "Hostuitwisseling",
  devenir_membre: "Word lid",
  se_d_connecter: "Uitloggen",
  mon_espace: "Mijn ruimte",
  connexion: "Verbinding",
  connect_: "Aangesloten",
  visuel_en_cours_de_g_n_ration_ai___: "Visueel gegenereerde AI...",
  tableau_de_bord: "Dashboard",
  mes_annonces: "Mijn advertenties",
  o__je_veux_aller: "Waar ik heen wil",
  qui_veut_venir_chez_moi: "Slim matchen",
  destinations: "Bestemmingen",
  carte_des_membres: "Leden kaart",
  calendrier: "Kalender",
  votre_coffre: "Jouw kluis",
  favoris: "Favorieten",
  messages: "Berichten",
  mon_profil: "Mijn profiel",
  pr_f_rences: "Voorkeuren",
  profil: "Profiel",
  h_te: "Gastheer",
  membre_fondateur: "Stichtend lid",
  membre: "Lid",
  r_duire__tendre: "Verkleinen/uitbreiden",
  r_duire_le_menu: "Menu samenvouwen",
  cette_page_n_a_pas__t__g_n_r_e: "Deze pagina is niet gegenereerd",
  donne_moi_plus_de_d_tails_sur_cette_page_pour_que_je_puisse_la_g_n_rer:
    "Geef me meer details over deze pagina, zodat ik deze kan genereren",
  connexion_en_cours___: "Verbinding wordt uitgevoerd...",
  email_ou_mot_de_passe_incorrect: "Onjuist e-mailadres of wachtwoord",
  une_erreur_est_survenue: "Er is een fout opgetreden",
  erreur_de_connexion_google: "Google-verbindingsfout",
  connecte_toi_pour_retrouver_ta_communaut_: "Log in om uw community te vinden",
  rejoins_la_communaut__des_h_tes_traveltrok:
    "Sluit u aan bij de DONKEY TRAVEL-hostcommunity",
  inscription: "Registratie",
  continuer_avec_google: "Ga verder met Google",
  ou: "Of",
  ton_pr_nom_et_nom: "Je voor- en achternaam",
  jean_h_mar: "Jean Hemar",
  lien_annonce_airbnb: "Link naar je Airbnb-advertentie",
  veuillez_saisir_un_lien_airbnb_valide: "Geef een geldige Airbnb-link op",
  lien_calendrier_ical: "iCal-link naar je Airbnb-agenda (voorlopig optioneel)",
  lien_ical_explication_lecture_seule:
    "Donkey Travel wijzigt nooit uw Airbnb-kalender. We lezen het alleen om uw beschikbaarheid te tonen. Je moet je inwisselingsdata op Airbnb handmatig blijven blokkeren om dubbele boekingen te voorkomen.",
  note_airbnb: "Airbnb-beoordeling",
  abonnement: "Abonnement",
  europe_unique___50eur_an: "Eén Europa - 50 EUR/jaar",
  offre_lancement_2026__25eur_an___50__:
    "Lanceringsaanbod 2026: 25EUR/jaar (-50%)",
  prix_garanti___vie_pour_les_1000_premiers_inscrits_:
    "Levenslange prijsgarantie voor de eerste 1000 registraties.",
  mot_de_passe: "Wachtwoord",
  "8_caract_res_minimum": "Minimaal 8 tekens",
  connexion___: "Verbinding...",
  cr_ation_du_compte___: "Het account aanmaken...",
  se_connecter: "Inloggen",
  cr_er_mon_compte: "Maak mijn account aan",
  mot_de_passe_oubli___: "Wachtwoord vergeten?",
  en_cr_ant_un_compte__tu_acceptes_nos_:
    "Door een account aan te maken, gaat u akkoord met onze",
  cgu: "CGU",
  _et_notre_: "en onze",
  politique_de_confidentialit_: "Privacybeleid",
  r_servation_de_logements: "Reservering van accommodatie",
  support_h_te_prioritaire: "Prioritaire hostondersteuning",
  carte___filtres_avanc_s: "Kaart + geavanceerde filters",
  flux_de_r_servation__tape_par__tape: "Stap-voor-stap boekingsproces",
  couverture_dommages_assistance: "Schade-/bijstandsdekking",
  multi_logements___reporting: "Multi-housing + rapportage",
  comparatif_des_modes: "Vergelijking van modi",
  ce_que_tu_actives_selon_ton_usage_traveltrok_:
    "Wat u activeert op basis van uw TRAVELTROK-gebruik.",
  fonction: "Functie",
  voyageur: "Reiziger",
  pro: "Pro",
  abonnement_europe_unique: "Enkel Europa-abonnement",
  rejoindre_le_club_europe: "Sluit je aan bij de Europaclub",
  basse_saison: "Laagseizoen",
  pause: "Neem een ​​pauze",
  rencontres: "Maak kennis met hosts",
  _conomies: "Besparingen",
  quota_atteint: "Quotum bereikt",
  _ligibilit_: "Geschiktheid",
  zone_d__change: "Wissel gebied",
  toute_l_europe: "Heel Europa",
  mod_le: "Model",
  abonnement_unique_annuel: "Eenmalig jaarabonnement",
  propri_taire_europ_en_en_pause: "Europese eigenaar op pauze",
  v_rification: "Verificatie",
  h_tes_certifi_s: "Gecertificeerde gastheren",
  abonnement_unique_traveltrok: "Enkel abonnement DONKEY TRAVEL",
  offre_lancement_2026__25eur_an_au_lieu_de_50eur_an:
    "Lanceringsaanbieding 2026: 25EUR/jaar in plaats van 50EUR/jaar",
  pourquoi_ce_club_fonctionne_pour_les_h_tes:
    "Waarom deze club voor hosts werkt",
  chez_traveltrok__vos_donn_es_ne_sont_pas_un_produit_:
    "Bij DONKEY TRAVEL zijn uw gegevens geen product.",
  nous_ne_vendons_jamais_les_informations_de_nos_membres_:
    "Wij verkopen nooit de gegevens van onze leden.",
  nous_ne_partageons_aucune_donn_e_avec_des_tiers___des_fins_commerciales_:
    "Wij delen geen gegevens met derden voor commerciële doeleinden.",
  le_site_est_s_curis__et_vos__changes_restent_priv_s_:
    "De site is beveiligd en uw uitwisselingen blijven privé.",
  traveltrok_est_garanti_sans_publicit____vous__tes_le_membre__pas_le_produit_:
    "DONKEY TRAVEL is gegarandeerd reclamevrij: jij bent het lid, niet het product.",
  rejoindre_le_club: "Sluit je aan bij de club",
  trouver_un_h_te: "Zoek een gastheer",
  proposer_un__change: "Stel een uitwisseling voor",
  synchronisation_mise___jour_avec_succ_s:
    "Synchronisatie succesvol bijgewerkt",
  erreur_lors_de_la_mise___jour: "Fout tijdens update",
  indisponible: "Niet beschikbaar",
  r_serv_: "Reserveren",
  erreur_chargement: "Fout bij laden",
  inconnue: "Onbekend",
  impossible_de_r_cup_rer_le_calendrier_ical__v_rifiez_l_url_ical_airbnb_et_r_essayez_:
    "Kan iCal-agenda niet herstellen. Controleer de iCal Airbnb-URL en probeer het opnieuw.",
  r_servation: "Reservering",
  _v_nements_synchronis_s: "gesynchroniseerde gebeurtenissen",
  _v_nements_import_s: "geïmporteerde evenementen",
  erreur_sync: "Synchronisatiefout",
  _chec_de_synchronisation: "Synchronisatie mislukt",
  dates_bloqu_es_avec_succ_s: "Datums succesvol geblokkeerd",
  erreur_blocage: "Blokkeerfout",
  mois: "Maand",
  aujourd_hui: "Vandaag",
  d_tails: "Details",
  actions: "Acties",
  bloquer: "Om te blokkeren",
  filtres: "Filters",
  confirm_: "Bevestigd",
  en_attente: "In de wacht",
  proposition: "Voorstel",
  bloqu_: "Geblokkeerd",
  synchronisation: "Synchronisatie",
  configurer: "Configureer",
  airbnb_connect_: "Airbnb verbonden",
  derni_re_synchro_r_ussie: "Laatste succesvolle synchronisatie",
  derni_re_synchro_en__chec: "Laatste mislukte synchronisatie",
  calendrier_connect___lancez_une_synchro_pour_importer_vos_r_servations_airbnb_:
    "Verbonden kalender. Start een synchronisatie om uw Airbnb-reserveringen te importeren.",
  synchro___: "Synchroniseren...",
  forcer_la_synchro: "Forceer synchronisatie",
  non_synchronis_: "Niet gesynchroniseerd",
  connectez_votre_calendrier_airbnb_pour__viter_les_doubles_r_servations__:
    "Koppel je Airbnb-kalender om dubbele boekingen te voorkomen!",
  bloquer_des_dates: "Datums blokkeren",
  s_lection: "Selectie",
  jours: "dagen",
  raison__optionnel__ex__travaux_: "Reden (optioneel, bijvoorbeeld: werken)",
  annuler: "Annuleren",
  confirmer: "Bevestigen",
  synchronisation_airbnb: "Airbnb-synchronisatie",
  ajoutez_vos_liens_airbnb_pour_synchroniser_automatiquement_vos_r_servations_et__viter_les_doublons_:
    "Voeg je Airbnb-links toe om je reserveringen automatisch te synchroniseren en duplicaten te voorkomen.",
  lien_de_l_annonce_airbnb: "Airbnb-advertentielink",
  airbnb_ical_calendar_link: "Airbnb iCal-agendalink",
  disponible_dans_param_tres_de_l_annonce_export_du_calendrier:
    "Beschikbaar in Aankondigingsinstellingen Kalender exporteren",
  enregistrer: "Redden",
  veuillez_cliquer_sur__localiser__pour_valider_l_adresse_avant_de_continuer_:
    "Klik op 'Zoeken' om het adres te valideren voordat u verdergaat.",
  vous_devez__tre_connect__pour_publier_:
    "Je moet ingelogd zijn om te kunnen posten.",
  id_manquant_apr_s_sauvegarde: "ID ontbreekt na back-up",
  erreur_upload_photo: "Fout bij het uploaden van foto's",
  erreur_sauvegarde_metadata_photos: "Fout bij opslaan van metagegevensfoto's",
  une_erreur_est_survenue_lors_de_la_sauvegarde:
    "Er is een fout opgetreden tijdens het opslaan",
  quitter: "Om te vertrekken",
  modification: "Bewerking",
  cr_ation: "Creatie",
  _tape: "Fase",
  sur: "op",
  sauvegarde_en_cours___: "Back-up wordt uitgevoerd...",
  retour: "Rug",
  sauvegarde___: "Back-up...",
  mettre___jour: "Om te updaten",
  publier_l_annonce: "Publiceer de advertentie",
  suivant: "Volgende",
  _tes_vous_s_r_de_vouloir_supprimer_cette_annonce__:
    "Weet u zeker dat u deze advertentie wilt verwijderen?",
  impossible_de_supprimer_l_annonce__: "Kan advertentie niet verwijderen:",
  g_rez_vos_logements_et_leur_disponibilit__:
    "Beheer uw accommodaties en hun beschikbaarheid.",
  ajouter_une_annonce: "Voeg een advertentie toe",
  vous_n_avez_aucune_annonce: "Je hebt geen advertenties",
  commencez___gagner_un_revenu_en_louant_votre_logement__c_est_simple_et_rapide_:
    "Begin met het verdienen van inkomsten door uw huis te verhuren. Het is snel en gemakkelijk.",
  cr_er_ma_premi_re_annonce: "Maak mijn eerste advertentie",
  publi_: "Gepubliceerd",
  brouillon: "Voorlopige versie",
  __nuit: "/ nacht",
  voir_l_annonce: "Zie de advertentie",
  modifier: "Wijzigen",
  supprimer: "VERWIJDEREN",
  quels__quipements_proposez_vous__: "Welke apparatuur biedt u aan?",
  s_lectionnez_tout_ce_qui_est_disponible_pour_les_voyageurs_:
    "Selecteer alles wat beschikbaar is voor reizigers.",
  aucun_sch_ma_conversation_compatible_trouv_:
    "Geen compatibel gespreksdiagram gevonden.",
  logements_concern_s: "huisvesting betreft",
  logement_non_pr_cis_: "Accommodatie niet gespecificeerd",
  erreur_lors_de_l_envoi_du_message_: "Fout bij verzenden van bericht.",
  rechercher_une_conversation: "Zoek een gesprek",
  demandes_re_ues: "Ontvangen verzoeken",
  mes_demandes: "Mijn verzoeken",
  aucune_demande_re_ue_: "Geen verzoeken ontvangen.",
  aucune_demande_envoy_e_: "Geen verzoek verzonden.",
  photo_de_profil: "Profielfoto",
  localisation_non_pr_cis_e: "Locatie niet gespecificeerd",
  listing_: "Lijst:",
  en_ligne: "Online",
  vous: "JIJ",
  _crivez_votre_message___: "Schrijf uw bericht...",
  s_lectionnez_une_conversation: "Selecteer een gesprek",
  pour_commencer___changer: "om te beginnen met handelen",
  logement_propos_: "Voorgestelde accommodatie",
  description_non_pr_cis_e: "Beschrijving niet gespecificeerd",
  ch_: "ch.",
  voy_: "zien.",
  nuit: "nacht",
  prix_non_pr_cis_: "Prijs niet gespecificeerd",
  voir: "Zien",
  aucune_annonce_li_e___cette_conversation_:
    "Geen mededelingen gerelateerd aan dit gesprek.",
  s_lectionnez_une_conversation_pour_voir_les_d_tails_:
    "Selecteer een gesprek om details te bekijken.",
  bonjour: "Goedemorgen",
  voici_ce_qui_se_passe_sur_votre_compte_aujourd_hui_:
    "Dit is wat er vandaag in uw account gebeurt.",
  annonces_en_ligne: "Online advertenties",
  nouveaux_messages: "Nieuwe berichten",
  prochains__changes: "Volgende uitwisselingen",
  matching_section__o__je_veux_aller: "Overeenkomende sectie: Waar ik heen wil",
  ajoutez_jusqu__10_villes_avec_rayon_en_km_et_vos_dates_de_d_part_pour_recevoir_des_propositions_mieux_cibl_es_:
    "Voeg maximaal 10 steden met een straal in km en uw vertrekdata toe om gerichtere voorstellen te ontvangen.",
  configurer_mes_pr_f_rences: "Configureer mijn voorkeuren",
  pr_t___recevoir_vos_premiers_voyageurs__:
    "Klaar om uw eerste reizigers te verwelkomen?",
  compl_tez_votre_profil_et_publiez_votre_premi_re_annonce_pour_commencer_____changer_votre_logement_avec_la_communaut__traveltrok_:
    "Vul uw profiel in en plaats uw eerste advertentie om uw accommodatie uit te wisselen met de TravelUitwisseling-gemeenschap.",
  cr_er_mon_annonce: "Maak mijn advertentie",
  compl_ter_mon_profil: "Vul mijn profiel in",
  impossible_de_charger_vos_preferences_: "Kan uw voorkeuren niet laden.",
  preferences_enregistrees_: "Opgeslagen voorkeuren.",
  impossible_d_enregistrer_vos_preferences_: "Kan uw voorkeuren niet opslaan.",
  impossible_de_supprimer_votre_profil_: "Kan uw profiel niet verwijderen.",
  chargement_des_preferences___: "Voorkeuren laden...",
  unites_de_distance: "Afstandseenheden",
  kilom_tres__km_: "Kilometers (km)",
  format_europeen_par_defaut: "Standaard Europees formaat",
  miles__mi_: "Mijlen (mi)",
  format_anglo_saxon: "Angelsaksisch formaat",
  visibilite_du_profil: "Profielzichtbaarheid",
  mettre_mon_profil_en_pause: "Pauzeer mijn profiel",
  me_masquer_dans_les_resultats_de_recherche:
    "Verberg mij in de zoekresultaten",
  zone_sensible: "Gevoelig gebied",
  suppression___: "Verwijdering...",
  supprimer_mon_profil: "Verwijder mijn profiel",
  pensez_a_enregistrer_vos_modifications_:
    "Vergeet niet uw wijzigingen op te slaan.",
  enregistrement___: "Registratie...",
  enregistrer_les_preferences: "Bewaar voorkeuren",
  impossible_de_charger_votre_profil_: "Kan uw profiel niet laden.",
  profil_enregistr__partiellement__la_base_de_donn_es_doit__tre_mise___jour__migration_sql__:
    "Profiel gedeeltelijk opgeslagen. De database moet worden bijgewerkt (SQL-migratie).",
  profil_mis___jour_avec_succ_s_: "Profiel is succesvol bijgewerkt.",
  profil_non_enregistr___la_base_de_donn_es_doit__tre_migr_e__colonnes_manquantes__:
    "Profiel niet opgeslagen: database moet worden gemigreerd (ontbrekende kolommen).",
  profil_non_enregistr___trop_de_colonnes_manquantes__lancez_la_migration_sql_:
    "Profiel niet opgeslagen: er ontbreken te veel kolommen. Start de SQL-migratie.",
  votre_base_de_donn_es_n_est_pas___jour__lancez_la_migration_sql_puis_r_essayez_:
    "Uw database is niet up-to-date. Voer de SQL-migratie uit en probeer het opnieuw.",
  erreur_lors_de_la_mise___jour_: "Fout tijdens update.",
  photo_de_profil_mise___jour_: "Bijgewerkte profielfoto.",
  erreur_upload_photo_: "Fout bij het uploaden van foto's.",
  photo_de_couverture_mise___jour_: "Bijgewerkte omslagfoto.",
  erreur_upload_couverture_: "Uploadfout omslag.",
  document_envoy__pour_v_rification_: "Document ter verificatie verzonden.",
  erreur_lors_de_l_envoi_du_document_: "Fout bij verzenden van document.",
  impossible_de_charger_votre_profil_pour_le_moment_:
    "Kan uw profiel momenteel niet laden.",
  mon_profil_h_te: "Mijn hostprofiel",
  identit___r_seaux_et_infos_de_matching:
    "Identiteit, netwerken en bijpassende informatie",
  plus_votre_profil_est_complet__plus_le_moteur_peut_proposer_des_h_tes_compatibles_:
    "Hoe completer uw profiel is, hoe meer compatibele hosts de engine kan voorstellen.",
  compl_tude_du_profil: "Volledigheid van het profiel",
  couverture: "Deken",
  photo_principale: "Hoofdfoto",
  h_te_traveltrok: "Gastheer EZELTRAVEL",
  localisation_non_renseign_e: "Locatie niet opgegeven",
  ajoutez_une_photo_large_pour_mieux_pr_senter_votre_univers_d_h_te_:
    "Voeg een grote foto toe om uw gastwereld beter te presenteren.",
  destinations_cibl_es: "Gerichte bestemmingen",
  dates_pr_vues: "Geplande data",
  configurer___o__je_veux_aller__: "Configureer “Waar ik heen wil”",
  statut_identit_: "Identiteitsstatus",
  v_rifi_: "Geverifieerd",
  en_cours: "In uitvoering",
  non_v_rifi_: "Niet geverifieerd",
  ajoutez_une_pi_ce_d_identit__pour_renforcer_la_confiance_de_la_communaut__:
    "Voeg ID toe om vertrouwen in de gemeenschap op te bouwen.",
  envoyer_document: "Document verzenden",
  identit__et_contact: "Identiteit en contact",
  pr_nom: "Voornaam",
  nom: "Naam",
  pseudo_public: "Publieke bijnaam",
  email: "E-mail",
  t_l_phone: "Telefoon",
  r_seaux_et_liens: "Netwerken en verbindingen",
  site_web: "Website",
  localisation_et_mode_de_voyage: "Locatie en wijze van reizen",
  pays_de_r_sidence: "Land van verblijf",
  s_lectionnez_un_pays: "Selecteer een land",
  ville_de_r_sidence: "Woonplaats",
  amiens: "Amiens",
  combien_de_personnes_voyagent__: "Hoeveel mensen reizen?",
  voyagez_vous_avec_des_animaux__: "Reist u met dieren?",
  oui: "Ja",
  non: "Nee",
  voyagez_vous_avec_des_b_b_s__: "Reist u met baby's?",
  bio_h_te: "Gastheer biografie",
  pr_sentez_votre_style_d_accueil_et_votre_logement_:
    "Presenteer uw gastvrijheidsstijl en uw accommodatie.",
  pr_sentation_de_la_famille: "Presentatie van de familie",
  qui_voyage__habitudes__rythme__type_de_s_jour_recherch___:
    "Wie reist, gewoonten, tempo, soort verblijf gezocht...",
  compl_tez_aussi___o__je_veux_aller___pour_activer_un_matching_plus_pr_cis_:
    "Vul ook “Waar ik heen wil” in om nauwkeuriger matchen te activeren.",
  enregistrer_le_profil: "Profiel opslaan",
  horizon_contrat: "Contracthorizon",
  "24_mois_apres_le_1er_sejour": "24 maanden na het eerste verblijf",
  nuits_que_je_dois: "Nachten die ik verschuldigd ben",
  nuits_qu_on_me_doit: "Nachten die ik verschuldigd ben",
  echanges_ouverts: "Open uitwisselingen",
  echanges_proches_echeance: "Transacties die bijna volwassen zijn",
  alerte_solde_des_echanges: "Wisselsaldowaarschuwing",
  aucun_profil_a_risque_detecte_pour_le_moment_:
    "Momenteel is er geen risicoprofiel gedetecteerd.",
  contrats_en_cours: "Lopende contracten",
  personne: "Persoon",
  logement: "Accommodatie",
  contrat: "CONTRACT",
  dates: "Datums",
  echange_effectue: "Wissel gemaakt",
  solde_nuits: "Verkoopavonden",
  temps_restant: "Resterende tijd",
  "1er_sejour_": "1e verblijf:",
  echeance_: "Deadline:",
  ils_sont_venus__fait: "Ze kwamen: klaar",
  ils_sont_venus__en_attente: "Ze kwamen: wachtend",
  je_suis_alle__fait: "Ik ging: klaar",
  je_suis_alle__en_attente: "Ik ging: wachten",
  je_dois: "Ik moet",
  nuits: "nachten",
  on_me_doit: "Ik ben schuldig",
  carte_des_p_rim_tres_de_recherche: "Kaart van onderzoeksgebieden",
  villes_localis_es: "gelokaliseerde steden",
  mise___jour_de_la_carte___: "De kaart bijwerken...",
  vous_devez__tre_connect__pour_g_rer_vos_pr_f_rences_:
    "Om uw voorkeuren te beheren, moet u ingelogd zijn.",
  impossible_de_charger_vos_pr_f_rences_de_matching_pour_le_moment_:
    "Kan uw overeenkomende voorkeuren momenteel niet laden.",
  ajoutez_au_moins_une_ville_cible_pour_activer_le_matching_:
    "Voeg ten minste één doelstad toe om matching te activeren.",
  une_p_riode_a_une_date_de_fin_ant_rieure___la_date_de_d_part_:
    "Een periode heeft een einddatum die vóór de startdatum ligt.",
  s_lectionnez_au_moins_un_pays_si_vous_activez_le_filtre_de_contact_par_pays_:
    "Selecteer minimaal één land als u het contactfilter op land inschakelt.",
  pr_f_rences_enregistr_es__les_pays_cibl_s_sont_conserv_s_localement_tant_que_la_migration_sql_n_est_pas_appliqu_e_:
    "Opgeslagen voorkeuren. Getargete landen worden lokaal bewaard totdat SQL-migratie wordt toegepast.",
  pr_f_rences_de_matching_enregistr_es_avec_succ_s_:
    "Overeenkomende voorkeuren zijn succesvol opgeslagen.",
  pr_f_rences_non_enregistr_es__base_non_migr_e__lancez_la_migration_sql_:
    "Voorkeuren niet opgeslagen: database niet gemigreerd. Start de SQL-migratie.",
  erreur_lors_de_l_enregistrement_: "Fout bij opslaan.",
  matching_intelligent: "Slim matchen",
  indiquez_vos_villes_cibles_et_vos_p_riodes_de_d_part__traveltrok_pourra_proposer_les_h_tes_les_plus_compatibles_:
    "Geef uw doelsteden en uw vertrekperiodes aan: DONKEY TRAVEL kan de meest compatibele hosts aanbieden.",
  retour_au_profil: "Terug naar profiel",
  villes_et_rayon_de_recherche: "Steden en zoekradius",
  jusqu___10_villes__ex__amiens_2_km__paris_5_km__lille_20_km__:
    "Maximaal 10 steden (bijvoorbeeld: Amiens 2 km, Parijs 5 km, Lille 20 km).",
  villes_actives: "actieve steden",
  ville: "Stad",
  choisir_un_pays: "Kies een land",
  saisissez_une_ville: "Voer een stad in",
  choisissez_le_pays_d_abord: "Kies eerst het land",
  rayon: "Radius",
  supprimer_cette_ville: "Verwijder deze stad",
  ajouter_une_ville: "Voeg een stad toe",
  ces_villes_seront_utilis_es_pour_proposer_des_changes_cibl_s_:
    "Deze steden zullen worden gebruikt om gerichte uitwisselingen aan te bieden.",
  enregistrer_mes_pr_f_rences: "Bewaar mijn voorkeuren",
  pays_d_europe___visiter: "Europese landen om te bezoeken",
  cochez_les_pays_qui_vous_int_ressent__vous_pouvez_ensuite_limiter_les_prises_de_contact___ces_pays_:
    "Vink de landen aan die u interesseren. Vervolgens kunt u de contacten tot deze landen beperken.",
  pays_s_lectionn_s: "geselecteerde landen",
  tout_cocher: "Controleer alles",
  tout_d_cocher: "Schakel alles uit",
  _tre_contact__uniquement_par_les_membres_de_ces_pays:
    "Alleen gecontacteerd worden door leden uit deze landen",
  ce_filtre_sera_utilis__dans_votre_matching_automatique_:
    "Dit filter wordt gebruikt bij uw automatische matching.",
  union_europ_enne: "Europese Unie",
  hors_union_europ_enne: "Buiten de Europese Unie",
  agenda_des_d_parts_souhait_s: "Schema van gewenste vertrekken",
  ajoutez_les_p_riodes_o__vous_souhaitez_partir_pour_lancer_un_matching_sur_des_cr_neaux_communs_:
    "Voeg de periodes toe waarin je wilt vertrekken om te beginnen met matchen op gemeenschappelijke slots.",
  p_riode_s__active_s_: "actieve periode(s)",
  aucune_p_riode_ajout_e_pour_le_moment_:
    "Er zijn nog geen periodes toegevoegd.",
  p_riode: "Periode",
  supprimer_cette_p_riode: "Verwijder deze periode",
  d_part: "Vertrek",
  commentaire__optionnel_: "Opmerking (optioneel)",
  ajouter_une_p_riode: "Voeg een punt toe",
  r_sum__matching: "Samenvatting matching",
  villes_cibles: "Doelsteden",
  rayon_moyen: "Gemiddelde straal",
  p_riodes_planifi_es: "Geplande periodes",
  pays_cibl_s: "Gerichte landen",
  contacts_limit_s_aux_pays_coch_s: "Contacten beperkt tot aangevinkte landen",
  contacts_ouverts___tous_les_pays: "Contacten open voor alle landen",
  agenda_aper_u: "Agenda-overzicht",
  ajoutez_une_p_riode_pour_afficher_votre_agenda_de_d_part_:
    "Voeg een periode toe om uw vertrekkalender weer te geven.",
  sans_commentaire: "Geen commentaar",
  logement_traveltrok: "DONKEY TRAVEL accommodatie",
  localisation_a_preciser: "Locatie nader te specificeren",
  logements_trouves: "accommodatie gevonden",
  plus_recents: "Meest recente",
  capacite_max: "Maximale capaciteit",
  h_tes: "Gastheren",
  villes: "Steden",
  logements_disponibles: "Accommodaties beschikbaar",
  pays_disponibles: "Beschikbare landen",
  marie_accepte__: "Marie accepteert!",
  nuits_a_reims_contre: "nachten in Reims tegen",
  nuits_a_paris: "nachten in Parijs",
  l_histoire_de_marie_jean: "Het verhaal van Marie & Jean",
  "1__marie_consulte_l_agenda_de_jean":
    "1. Marie raadpleegt het dagboek van Jean",
  elle_voit_que_jean_a_des_dates_libres_dans_2_semaines__parfait_pour_elle___jean_confirme_qu_il_peut_liberer_ces_dates_:
    "Ze ziet dat Jean over twee weken vrije dates heeft. Ideaal voor haar! Jean bevestigt dat hij deze data kan vrijgeven.",
  h_tes_actifs: "Actieve gastheren",
  pays_couverts: "Landen die gedekt zijn",
  echanges_realises: "Uitwisselingen gemaakt",
  "100__match": "100% overeenkomst",
  echanges_longue_distance: "Uitwisselingen over lange afstanden",
  matching_algorithmique_intelligent: "Intelligente algoritmische matching",
  notre_algorithme_croise_les_informations_de_votre_profil_et_de_vos_recherches_pour_vous_proposer_toutes_les_annonces_de_logements_qui_correspondent_exactement_a_votre_demande_:
    "Ons algoritme kruist de informatie uit uw profiel en uw zoekopdrachten om u alle woningadvertenties aan te bieden die precies overeenkomen met uw verzoek.",
  matching_precis: "Nauwkeurige afstemming",
  analyse_intelligente_de_vos_crit_res: "Intelligente analyse van uw criteria",
  gain_de_temps_dans_vos_recherches: "Bespaar tijd bij uw onderzoek",
  propositions_ultra_pertinentes: "Ultra-relevante voorstellen",
  habitants: "Bewoners",
  destinations_europeennes: "Europese bestemmingen",
  decouvrez_les_merveilles_du_continent: "Ontdek de wonderen van het continent",
  pays_actifs_sur_traveltrok: "Landen actief op DONKEY TRAVEL",
  selectionner_un_pays: "Selecteer een land",
  union_europeenne: "Europese Unie",
  hors_union_europeenne: "Buiten de Europese Unie",
  fiche_detaillee: "Gedetailleerd blad",
  selectionnez_un_pays_dans_la_liste_ou_sur_la_carte_pour_decouvrir_climat__population_et_lieux_emblematiques_:
    "Selecteer een land uit de lijst of op de kaart om het klimaat, de bevolking en emblematische plaatsen te ontdekken.",
  logements_actifs: "actieve huisvesting",
  climat: "Klimaat",
  information_touristique: "Toeristische informatie",
  lieux_emblematiques: "Iconische plaatsen",
  gastronomie: "Gastronomie",
  dom_tom___outre_mer: "DOM-TOM / Overzee",
  villes_principales: "Belangrijkste steden",
  charte_officielle: "Officieel charter",
  confiance_mutuelle: "Wederzijds vertrouwen",
  r_gles_claires: "Duidelijke regels",
  sanctions_applicables: "Toepasselijke sancties",
  illustration_3d_des_engagements: "3D illustratie van toezeggingen",
  concept_3d_informations: "3D-afbeelding van details",
  principe_1: "Principe 1",
  v_racit__des_informations: "Waarheid van informatie",
  profil__logement__photos_et_prix_doivent__tre_exacts_:
    "Profiel, accommodatie, foto's en prijzen moeten accuraat zijn.",
  concept_3d_respect_du_lieu: "3D-beeld van respect voor de plaats",
  principe_2: "Principe 2",
  respect_du_lieu: "Respect voor de plek",
  aucune_f_te_et_z_ro_nuisance_pour_le_voisinage_:
    "Geen feestjes en geen overlast voor de buurt.",
  concept_3d_fiabilit__contractuelle: "Contractconcept in 3D",
  principe_3: "Principe 3",
  fiabilit__contractuelle: "Contractuele betrouwbaarheid",
  dates_bloqu_es___engagement_ferme__sauf_raison_valable_:
    "Geblokkeerde data = harde toezegging, tenzij er een geldige reden is.",
  engagements_c_t__voyageur: "Toezeggingen aan de passagierszijde",
  engagements_c_t__h_te: "Toezeggingen aan de hostzijde",
  annulations_et_reports: "Annuleringen en uitstel",
  r_gle_op_rationnelle: "Operationele regel",
  check_list_d_part_voyageur: "Controlelijst voor vertrek",
  cuisine_et_vaisselle_propres: "Schone keuken en serviesgoed",
  sols_et_surfaces_rendus_propres: "Vloeren en oppervlakken schoon gemaakt",
  linge_utilis__d_pos__selon_consigne:
    "Gebruikt linnengoed gestort volgens instructies",
  aucune_invitation_non_autoris_e_pendant_le_s_jour:
    "Geen ongeautoriseerde uitnodigingen",
  _tat_final_du_logement_confirm__avec_photos:
    "Eindtoestand van de behuizing bevestigd",
  sanctions_en_cas_de_manquement: "Sancties bij niet-naleving",
  ce_que_permet_traveltrok: "Wat DONKEY TRAVEL toestaat",
  vous_pouvez_inscrire_autant_de_logements_que_vous_voulez_:
    "U kunt zoveel accommodaties opgeven als u wilt.",
  vous_pouvez__changer_autant_de_fois_que_vous_voulez_dans_l_ann_e_:
    "Uitwisseling zonder herhalingslimiet gedurende het jaar.",
  chaque__change_repose_sur_un_contrat_clair_entre_deux_h_tes_:
    "Een formeel contract bindt hosts officieel en garandeert succes.",
  r_f_rences_de_bonnes_pratiques: "Referenties voor beste praktijken",
  un_club_s_rieux__une_communaut__durable:
    "Een serieuze club creëert een duurzame gemeenschap",
  retour_au_guide_complet: "Terug naar de volledige gids",
  carte_des_logements_traveltrok: "DONKEY TRAVEL accommodatiekaart",
  points_logements: "Accommodatie punten",
  aucune_donnee_geolocalisee_pour_le_moment_:
    "Er zijn momenteel geen geolocatiegegevens beschikbaar.",
  envie_d_entrer_dans_la_carte__: "Wil je op de kaart komen?",
  chargement_des_logements___: "Behuizing laden...",
  la_date_d_arriv_e_est_requise: "Aankomstdatum is vereist",
  la_date_ne_peut_pas__tre_dans_le_pass_:
    "De datum mag niet in het verleden liggen",
  la_date_de_d_part_est_requise: "Vertrekdatum is vereist",
  la_date_de_d_part_doit__tre_apr_s_l_arriv_e:
    "De vertrekdatum moet na aankomst zijn",
  le_message_doit_contenir_au_moins_10_caract_res:
    "Het bericht moet minimaal 10 tekens bevatten",
  veuillez_corriger_les_erreurs_ci_dessus: "Corrigeer de bovenstaande fouten",
  une_erreur_est_survenue__veuillez_r_essayer_:
    "Er is een fout opgetreden. Probeer het opnieuw.",
  paris__france: "Parijs, Frankrijk",
  mode_h_te: "Host-modus",
  je_loue_quelques_semaines_par_an__le_mod_le_1eur___nuit_est_super_simple___expliquer_aux_voyageurs_:
    "Ik huur een paar weken per jaar. Het 1EUR/nacht-model is supereenvoudig uit te leggen aan reizigers.",
  "37_nuits": "37 nachten",
  lyon__france: "Lyon, Frankrijk",
  mode_voyageur: "Reiziger mode",
  la_r_servation_est_fluide__et_surtout_les_frais_sont_lisibles__je_compare_facilement_le_co_t_final_avant_de_confirmer_:
    "De reservering verloopt soepel en vooral de kosten zijn leesbaar. Ik vergelijk eenvoudig de uiteindelijke kosten voordat ik bevestig.",
  "22_nuits": "22 nachten",
  bordeaux__france: "Bordeaux, Frankrijk",
  "54_nuits": "54 nachten",
  marseille__france: "Marseille, Frankrijk",
  pro_multi_logements: "Pro meerwoning",
  avec_plusieurs_biens__la_version_pro_me_fait_gagner__norm_ment_de_temps_sur_le_calendrier_et_la_gestion_des_demandes_:
    "Met meerdere eigenschappen bespaart de Pro-versie mij veel tijd bij het plannen en beheren van aanvragen.",
  "9_logements": "9 accommodaties",
  retours_utilisateurs: "Feedback van gebruikers",
  des_retours_terrain_concrets: "Concrete veldfeedback",
  des_voyageurs_et_h_tes_qui_veulent_une_location_plus_claire_et_plus_abordable_:
    "Reizigers en verhuurders die een duidelijkere en meer betaalbare huurwoning willen.",
  activit_: "activiteit",
  _conomie_estim_e: "geschatte besparingen",
  profils_et_logements_v_rifi_s: "Geverifieerde profielen en accommodaties",
  exp_rience_location_simplifi_e: "Vereenvoudigde huurervaring",
  co_ts_transparents___la_nuit: "Transparante kosten 's nachts",
  marquer_des_dates: "Datums markeren",
  je_peux_accueillir: "Ik kan het huisvesten",
  je_veux_partir: "Ik wil weggaan",
  partir_et_accueillir: "Vertrek en welkom",
  accueillir: "Om te verwelkomen",
  partir: "Vertrekken",
  bloquer_les_dates: "Datums blokkeren",
  toujours_partir_et_accueillir: "Ga altijd weg en welkom",
  rendre_ce_logement_visible: "Maak deze accommodatie zichtbaar",
  rendre_ce_logement_invisible: "Maak deze accommodatie onzichtbaar",
  confirmation_visibilite_logement:
    "Weet je zeker dat je de zichtbaarheid van DEZE vermelding voor andere leden wilt wijzigen?",
  confirmer_activer_toujours_partir_accueillir:
    "Door deze modus te activeren, worden nieuwe 'Verlaat en welkom'-beschikbaarheid toegevoegd die vanaf vandaag altijd de komende 2 jaar dekken. Andere handmatige beschikbaarheden worden overschreven.\n\nWeet u zeker dat u wilt doorgaan?",
  confirmer_desactiver_toujours_partir_accueillir:
    "Weet je zeker dat je de modus 'Altijd weggaan en begroeten' wilt uitschakelen?",
  details_de_l_adresse__optionnel_: "Adresgegevens (optioneel)",
  rue_et_numero: "Straat en nummer",
  ex__12_rue_de_la_paix: "Bijv.: 12 rue de la Paix",
  appartement_suite: "Appartement, suite, enz.",
  ex__apt_4b: "Bijvoorbeeld: appartement 4B",
  etage: "Vloer",
  ex__3eme_sans_ascenseur: "Bijvoorbeeld: 3e",
  code_d_acces: "Toegangscode (deur/gebouw)",
  ex__a1234: "Bijv.: A1234",
  ces_informations_ne_seront_partagees_qu_avec_les_voyageurs_confirmes:
    "Deze gedetailleerde informatie wordt alleen meegedeeld aan leden die een bevestigde uitwisseling met u hebben.",
  lits_doubles: "Tweepersoonsbedden",
  lits_simples: "Eenpersoonsbedden",
  canapes_lits: "Slaapbanken",
  lits_bebes: "Babybedjes",
  amenity_cat_essentials: "De essentie",
  amenity_cat_kitchen: "Koken en maaltijden",
  amenity_cat_bathroom: "Badkamer",
  amenity_cat_bedroom_laundry: "Slaapkamer en linnengoed",
  amenity_cat_entertainment: "Amusement",
  amenity_cat_family: "Familie",
  amenity_cat_exterior: "Buiten",
  amenity_cat_features: "Functies",
  amenity_cat_location: "Locatie",
  amenity_cat_safety: "Beveiliging",
  amenity_wifi: "Wifi",
  amenity_workspace: "Speciale werkruimte",
  amenity_ac: "Airconditioning",
  amenity_heating: "Verwarming",
  amenity_kitchen: "Keuken",
  amenity_refrigerator: "Koelkast",
  amenity_microwave: "Magnetron",
  amenity_oven: "Oven",
  amenity_dishwasher: "Afwasmachine",
  amenity_coffee_maker: "Koffiezetapparaat",
  amenity_kettle: "Ketel",
  amenity_bathtub: "Bad",
  amenity_hair_dryer: "haardroger",
  amenity_shampoo: "Shampoo en douchegel",
  amenity_hot_water: "Heet water",
  amenity_washing_machine: "Wasmachine",
  amenity_dryer: "Droger",
  amenity_iron: "Ijzer",
  amenity_hangers: "Hangers",
  amenity_bed_linens: "Beddengoed voorzien",
  amenity_tv: "Televisie",
  amenity_game_console: "Spelconsole",
  amenity_books_toys: "Boeken en speelgoed",
  amenity_sound_system: "Audiosysteem",
  amenity_high_chair: "Hoge stoel",
  amenity_baby_bath: "Babybadje",
  amenity_travel_cot: "Reiswieg",
  amenity_changing_table: "Commode",
  amenity_patio: "Balkon of terras",
  amenity_garden: "Privé tuin",
  amenity_bbq: "Barbecue",
  amenity_outdoor_furniture: "Tuinmeubilair",
  amenity_pool: "Zwembad",
  amenity_hottub: "Jacuzzi",
  amenity_gym: "Sportschool",
  amenity_fireplace: "Schoorsteen",
  amenity_breakfast: "Ontbijt inbegrepen",
  amenity_parking: "Gratis parkeren",
  amenity_ev_charger: "EV-laadstation",
  amenity_beachfront: "Toegang tot het strand",
  amenity_ski_in_out: "Toegang tot de skipistes",
  amenity_lake_access: "Toegang tot het meer",
  amenity_smoke_detector: "Rookmelder",
  amenity_first_aid: "EHBO-doos",
  amenity_fire_extinguisher: "Brandblusser",
  amenity_sauna: "Sauna",
  amenity_massage_chair: "Massagestoel",
  amenity_shower: "Douche",
  amenity_home_cinema: "Thuisbioscoop",
  amenity_ping_pong: "Pingpongtafel",
  amenity_forest_access: "Toegang tot het bos",
  amenity_hiking_access: "Toegang tot wandelen",
  compl_t_: "voltooid",
  l_adresse_doit_tre_localis_e_sur_la_carte: "Het adres moet op de kaart staan",
  au_moins_3_photos_requises: "Er zijn minimaal 3 foto's vereist",
  le_titre_doit_faire_au_moins_10_caract_res:
    "De titel moet minimaal 10 tekens lang zijn",
  la_description_doit_faire_au_moins_50_caract:
    "De beschrijving moet minimaal 50 tekens lang zijn",
  s_lectionnez_au_moins_3_quipements: "Selecteer minimaal 3 apparatuur",
  encore_quelques_d_tails_avant_de_publier:
    "Nog enkele details vóór publicatie",
  votre_annonce_est_compl_t_e_x:
    "Uw advertentie is voltooid bij {{score}}%. Vul de ontbrekende elementen in om het te kunnen publiceren:",
  compl_ter: "Compleet",
  voici_comment_les_voyageurs_verront_votre_:
    "Dit is hoe reizigers uw vermelding te zien krijgen.",
  photo: "Foto",
  afficher_toutes_les_photos: "Laat alle foto's zien",
  h_t_par_vous: "• Gastheer: jij",
  description: "Over deze accommodatie",
  votre_description_appara_tra_ici: "Uw beschrijving verschijnt hier...",
  afficher_les_n__quipements_x: "Laat ze zien{{count}}apparatuur",
  ajouter_une_date: "Voeg een datum toe",
  aucun_montant_ne_vous_sera_d_bit_:
    "Er wordt op dit moment geen bedrag aan u in rekening gebracht",
  demander: "Vragen",
  enregistrer_et_quitter: "Opslaan en afsluiten",
  enregistrer_pour_plus_tard: "Bewaar voor later",
  conseils_pour_des_photos_r_ussies: "Tips voor succesvolle foto's",
  privil_giez_le_format_paysage__1:
    "Kies liggend formaat (16:9) voor een betere weergave.",
  prenez_vos_photos_de_jour__avec_:
    "Maak uw foto's overdag, met goed natuurlijk licht.",
  rangez_et_nettoyez_les_pi_ces_av:
    "Bewaar en reinig de stukken voordat u ze fotografeert.",
  mettez_en_avant_les_atouts_de_vo:
    "Breng de troeven van uw accommodatie onder de aandacht (uitzicht, terras, mooie woonkamer, enz.).",
  donnez_un_titre___votre_annonce: "Geef uw advertentie een titel",
  un_titre_court_et_accrocheur_attirera_pl:
    "Een korte en pakkende titel zal meer reizigers aantrekken.",
  souhaite_visiter: "Zou graag willen bezoeken",
  vous_propose_en_change: "Biedt jou in ruil",
  autres_logements: "andere accommodatie",
  voir_le_logement: "Bekijk de accommodatie",
  votre_demande_titre: "Uw verzoek",
  votre_demande_soustitre:
    "Samenvatting van uw reiswensen en metgezellen voor uw toekomstige uitwisselingen.",
  compagnons_de_voyage: "Reisgenoten",
  voyage_avec_bebe: "Baby's)",
  voyage_avec_animaux: "Huisdieren",
  disponibilites_souhaitees: "Gewenste beschikbaarheid",
  destinations_cibles: "Doelbestemmingen",
  aucune_date_precisee: "Er is geen reisdatum opgegeven.",
  aucune_destination_precisee: "Er is geen doelbestemming opgegeven.",
  votre_demande_menu: "Uw verzoek",
  modifier_mon_profil: "Bewerk mijn profiel",
  rayon_de: "Straal van{{km}}km",
  dates_flexibles_option: "Flexibele data",
  animaux_de_compagnie_details: "{{count}}dier/dieren",
  changer_d_annonce: "Advertentie wijzigen",
  profil_du_voyageur: "Reizigersprofiel",
  chambres_requises: "Vereiste kamers",
  animaux: "dier(en)",
  duree_du_sejour_souhaitee: "Gewenste verblijfsduur",
  combien_de_chambres_avez_vous_besoin__: "Hoeveel slaapkamers heb je nodig?",
  combien_de_b_b_s__: "Hoeveel baby's?",
  combien__: "Hoe veel ?",
  vos_animaux: "Jouw dieren",
  chien_s_: "Hond(en)",
  plus_de_30_nuits: "Meer dan 30 nachten",
  "community.hero.badge": "Onze gemeenschap",
  "community.hero.title": "Sluit u aan bij het meest authentieke hostnetwerk",
  "community.hero.subtitle":
    "Deel meer dan alleen uw huis. Ontdek verhalen, ontmoet gepassioneerde gastheren en reis met vertrouwen.",
  "community.stats.members": "Actieve leden",
  "community.stats.countries": "Vertegenwoordigde landen",
  "community.stats.exchanges": "Uitwisselingen gemaakt",
  "community.values.title": "Wat ons samenbrengt",
  "community.values.trust.title": "Absoluut vertrouwen",
  "community.values.trust.desc":
    "Elk lid is een geverifieerde gastheer, wat wederzijds respect voor het pand garandeert.",
  "community.values.sharing.title": "Delen en vergaderen",
  "community.values.sharing.desc":
    "De mogelijkheid om banden te creëren met de lokale bevolking in heel Europa.",
  "community.values.savings.title": "Echte besparingen",
  "community.values.savings.desc":
    "Reis vaker en verder, met behoud van uw budget.",
  "community.testimonials.title": "Verhalen van leden",
  "community.cta.title": "Klaar om deel uit te maken van het avontuur?",
  "community.cta.button": "Word vandaag nog lid",
  "blog.hero.badge": "Onze blog",
  "blog.hero.title": "Inspiratie & Tips",
  "blog.hero.subtitle":
    "Ontdek reisverhalen, tips voor het voorbereiden van uw accommodatie en wat er nieuw is bij de club.",
  "blog.categories.all": "Alle artikelen",
  "blog.categories.tips": "Hosttips",
  "blog.categories.inspiration": "Reisinspiratie",
  "blog.categories.news": "Nieuws",
  "blog.empty": "Momenteel geen artikelen. Kom snel terug!",
  "help.hero.badge": "Helpcentrum",
  "help.hero.title": "Hoe kunnen wij u helpen?",
  "help.hero.subtitle":
    "Vind snel antwoorden of neem contact op met ons ondersteuningsteam.",
  "help.search.placeholder": "Zoek naar een antwoord...",
  "help.categories.account.title": "Account & profiel",
  "help.categories.account.desc":
    "Beheer uw gegevens, wachtwoorden en voorkeuren.",
  "help.categories.exchanges.title": "Ruilen & Reserveringen",
  "help.categories.exchanges.desc":
    "Hoe u een ruil aanbiedt, accepteert of annuleert.",
  "help.categories.trust.title": "Vertrouwen en veiligheid",
  "help.categories.trust.desc":
    "Contracten, verificatie en bescherming van huisvesting.",
  "help.faq.title": "Veelgestelde vragen",
  "help.contact.cta": "Heeft u uw antwoord niet gevonden?",
  "help.contact.button": "Neem contact met ons op",
  "careers.hero.badge": "Sluit je aan bij het team",
  "careers.hero.title": "Laten we bouwen aan de toekomst van reizen",
  "careers.hero.subtitle":
    "We zijn op zoek naar gepassioneerde mensen die de manier waarop gasten in Europa reizen opnieuw gaan definiëren.",
  "careers.values.title": "Onze waarden",
  "careers.values.trust.title": "Menselijk en vertrouwen",
  "careers.values.remote.title": "Flex telewerken",
  "careers.values.impact.title": "Echte impact",
  "careers.openings.title": "Openstaande posities",
  "careers.openings.empty":
    "Er zijn momenteel geen vacatures open. Aarzel niet om een ​​spontane sollicitatie te sturen!",
  "careers.apply.title": "Spontane toepassing",
  "careers.apply.desc":
    "Stuur uw CV en vertel ons hoe u Donkey Travel kunt helpen.",
  "careers.apply.button": "Verstuur mijn sollicitatie",
  "contact.hero.badge": "Contact",
  "contact.hero.title": "Wij zijn er voor u",
  "contact.hero.subtitle":
    "Een vraag, suggestie of probleem? Ons team staat klaar om naar u te luisteren.",
  "contact.form.name": "Jouw naam",
  "contact.form.email": "Uw e-mail",
  "contact.form.subject": "Onderwerp van uw bericht",
  "contact.form.message": "Jouw bericht...",
  "contact.form.send": "Bericht verzenden",
  "contact.info.title": "Nuttige informatie",
  "contact.info.email": "contact@donkey.travel",
  "contact.info.address": "Haute-Somme-vallei, Picardië, Frankrijk",
  "contact.info.hours": "Ma - Vr: 9.00 - 18.00 uur",
  activez_votre_abonnement: "Activeer uw abonnement",
  finalisez_votre_inscription: "Rond uw registratie af",
  _changes_illimit_s_en_europe: "Onbeperkt ruilen in Europa",
  validit___1_an: "Geldigheid: 1 jaar",
  paiement_100__s_curis__par_paypal: "100% veilige betaling via PayPal",
  me_d_connecter_et_revenir_plus_tard: "Log uit en kom later terug",
  erreur_lors_de_la_validation_du_paiement_sur_n:
    "Fout bij het valideren van de betaling op onze servers.",
  le_paiement_n_a_pas_pu__tre_valid_:
    "De betaling kon niet worden gevalideerd.",
  une_erreur_inconnue_est_survenue_lors_du_paiem:
    "Er is een onbekende fout opgetreden tijdens de betaling.",
  impossible_d_initialiser_paypal__v_rifiez_vot:
    "Kan PayPal niet initialiseren. Controleer uw verbinding.",
  donn_es_personnelles: "Persoonlijke gegevens",
  rejoignez_notre_communaut__et_r_servez_un_logement:
    "Sluit u aan bij onze community en boek accommodatie in {{city}} met duidelijke vaste kosten en verzekering inbegrepen.",
  bienvenue: "Welkom",
  code_promo_applique_avec_succes: "Kortingscode succesvol toegepast!",
  cible: "Doel",
  propose: "Voorstellen",
  "1_sens": "1 zintuig",
  "2_sens": "2 zintuigen",
  ils_veulent_visiter_votre_region_br_c_est_a_vous:
    "Ze willen jouw omgeving bezoeken.<br />Het is aan jou om uit te zoeken waar ze wonen!",
  ils_cherchent_chez_vous_et_br_ils_habitent_la_ou:
    "Ze zijn op zoek naar jou EN<br />ze wonen waar jij heen wilt!",
  comment_ca_marche: "Hoe werkt het?",
  comprendre_les_differents_types_de_matching:
    "Inzicht in de verschillende soorten matching",
  match_reciproque: "Wederzijdse wedstrijd",
  details_de_la_demande: "Vraag details aan",
  souhaite_venir_dans_votre_secteur: "Ik kom graag naar uw regio:",
  peut_vous_accueillir: "Is geschikt voor u:",
  souhaite_visiter_dans_un_rayon:
    "Wilt u <strong>{{city}}</strong> bezoeken binnen een straal van <strong>{{radius}} km</strong>, uw accommodatie komt overeen met hun zoekopdracht.",
  souhaite_visiter_ville:
    "Wilt u <strong>{{city}}</strong> bezoeken, uw accommodatie komt overeen met hun zoekopdracht.",
  a_besoin_de_chambres: "Heeft {{count}} kamer(s) nodig.",
  comparateur_de_valeur: "Waardevergelijker",
  ecart: "gat",
  code_promo_invalide: "Ongeldige kortingscode",
  erreur_verification_code: "Fout bij controleren van code",
  vous_avez_un_code_promo: "Heeft u een kortingscode?",
  entrez_votre_code: "VOER UW CODE IN",
  appliquer: "Toepassen",
  importation_r_ussie_:
    "Importeren succesvol! Uw gegevens zijn vooraf ingevuld.",
  erreur_lors_de_l_importation: "Fout tijdens het importeren:",
  d_crivez_ce_qui_rend_votre_logement_uniq:
    "Beschrijf wat uw huis uniek maakt...",
  mettez_en_avant_les_points_forts___votre:
    "Benadruk de sterke punten van uw accommodatie",
  lien_annonce_airbnb_1: "Link naar je Airbnb-advertentie",
  importation___: "Importeren...",
  importer_l_annonce: "Advertentie importeren",
  renseignez_le_lien_de_votre_annonce_pou_:
    "Voer de link naar uw advertentie in. U kunt de gegevens automatisch importeren om tijd te besparen.",
  lien_calendrier_airbnb: "Agendalink (iCal)",
  nous_utiliserons_ce_lien_pour_synchroni:
    "Wij gebruiken deze link om uw beschikbaarheid te synchroniseren.",
  entrer_en_contact: "Neem contact op",
  attention___risque__lev__de_d_pendance_aux_voyages_gratuits__:
    "Waarschuwing: groot risico op verslaving aan gratis reizen!",
};
